import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

const categoryIcons: Record<string, string> = {
  action: 'ri-sword-line',
  comedy: 'ri-emotion-laugh-line',
  romance: 'ri-heart-line',
  'sci-fi': 'ri-rocket-line',
  horror: 'ri-ghost-line',
  drama: 'ri-film-line',
  animation: 'ri-paint-brush-line',
  documentary: 'ri-camera-line',
  'tv-series': 'ri-tv-line',
};

const categoryColors: Record<string, string> = {
  action: 'bg-accent-100 text-accent-700',
  comedy: 'bg-secondary-100 text-secondary-700',
  romance: 'bg-primary-100 text-primary-700',
  'sci-fi': 'bg-accent-100 text-accent-700',
  horror: 'bg-secondary-100 text-secondary-700',
  drama: 'bg-primary-100 text-primary-700',
  animation: 'bg-accent-100 text-accent-700',
  documentary: 'bg-secondary-100 text-secondary-700',
  'tv-series': 'bg-primary-100 text-primary-700',
};

export default function CategorySection() {
  const displayCategories = categories.filter(c => c.slug !== 'all');

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            影视分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型探索你喜爱的影视内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full ${categoryColors[cat.slug] || 'bg-secondary-100 text-secondary-700'} transition-transform duration-300 group-hover:scale-110`}>
                <i className={`${categoryIcons[cat.slug] || 'ri-movie-line'} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}